import websites from "./websites";
import services from "./services";

const result = [...websites, ...services];

export default result;
